export default "__VITE_ASSET__2oFjmwSX__"